<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Search Form</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="px-2 pt-4 pb-0">
                    <!-- <v-col lg="2" md="2" cols="12">
                      <v-text-field
                        label="Doc No"
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="docNo.value.value"
                        :error-messages="docNo.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-text-field>
                    </v-col> -->

                    <!-- <v-col lg="2" md="2" cols="12">
                      <v-text-field
                        label="Title"
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="title.value.value"
                        :error-messages="title.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-text-field>
                    </v-col> -->

                    <v-col lg="2" md="2" cols="12">
                      <v-select
                        label="Status"
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="status.value.value"
                        :error-messages="status.errorMessage.value"
                        :items="statusOptions"
                        clearable
                      ></v-select>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        label="From Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="from_date.value.value"
                        :error-messages="from_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        label="To Date"
                        density="compact"
                        single-line
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="to_date.value.value"
                        :error-messages="to_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="6">
                      <v-btn class="bg-brand" type="submit" ref="searchButton"
                        >Search</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid style="margin-top: -20px;">
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Document Record</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="4" cols="12">
                    <!-- <div class="d-flex align-center gap-2">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div> -->
                  </v-col>

                  <v-col md="4" cols="12" style="display:flex; justify-content: end;">
                    <!-- v-if="selectedDocuments.length > 0" -->
                     <!-- <v-btn
                        prepend-icon="mdi mdi-send"
                        variant="flat"
                        color="info"
                        @click="sendDocuments"
                        class="d-none"
                      >
                        Send ({{ selectedDocuments.length }})
                      </v-btn> -->
                     
                    <div class="text-right pr-2">
                      <v-btn
                        v-if="$insertAccess($route.fullPath)"
                        @click="openDocumentModal"
                        color="primary"
                        variant="tonal"
                        prepend-icon="mdi mdi-plus"
                        rounded="xl"
                      >
                        Add Document
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>

                <v-data-table
                  :headers="headers"
                  :items="documentList"
                  :loading="loading"
                  v-model:items-per-page="itemsPerPage"
                  :search="search"
                  :hover="true"
                  density="compact"
                  >
                  <!-- v-model="selectedDocuments" -->
                  <!-- return-object
                  :item-selectable="isApprovalProcessActive" -->
                  <!-- show-select -->
                  <!-- <template v-slot:header.data-table-select>
                    <v-checkbox
                      :model-value="selectedDocuments.length === documentList.length && documentList.length > 0"
                      :indeterminate="selectedDocuments.length > 0 && selectedDocuments.length < documentList.length"
                      @click="toggleSelectAll"
                    ></v-checkbox>
                  </template> -->

                  <template v-slot:item.index="{ index }">
                    {{ ++index }}
                  </template>

                  <template v-slot:item.doc_no="{ item }">
                    <span class="font-weight-medium">{{ item.doc_no || '-' }}</span>
                  </template>

                  
                  <template v-slot:item.approved_by="{ item }">
                    <span class="font-weight-medium">{{ item?.approval_current_process?.employee?.name ?? '-' }}</span>
                    <span v-if="item?.approval_current_process">({{ item?.approval_current_process?.employee?.branch?.name }})</span>
                  </template>

                  <template v-slot:item.approved_date="{ item }">
                    <span class="font-weight-medium">{{ formatDate(item?.approval_current_process?.created_at) ?? '-' }}</span>
                  </template>

                  <template v-slot:item.approved_status="{ item }">
                    <span class="font-weight-medium" :style="getApprovalColor(item?.approval_current_process?.status)">{{ item?.approval_current_process?.status ?? '-' }}</span>
                  </template>

                  <template v-slot:item.icon_slot="{ item }">
                    <v-avatar size="42" class="mr-3" :color="getFileColor(item)" variant="tonal" >
                      <v-icon size="22"> {{ getFileIcon(item) }}</v-icon>
                    </v-avatar>
                  </template>

                  <template v-slot:item.title="{ item }">
                    {{ item.title || '-' }}
                  </template>

                  <template v-slot:item.version="{ item }">
                    <v-chip
                      size="small"
                      color="info"
                      variant="outlined"
                    >
                      v{{ item.version || '1.0' }}
                    </v-chip>
                  </template>

                  <template v-slot:item.size_slot="{ item }">
                    {{ formatFileSize(item.size) }}
                  </template>
                  

                  <template v-slot:item.status="{ item }">
                    <v-chip
                      v-if="item.status == 1 || item.status === 'active'"
                      color="success"
                      size="small"
                      class="text-capitalize"
                      >Active</v-chip
                    >
                    <v-chip
                      v-else-if="item.status == 0 || item.status === 'inactive'"
                      color="red"
                      size="small"
                      class="text-capitalize"
                      >Inactive</v-chip
                    >
                    <v-chip
                      v-else-if="item.status === 'draft'"
                      color="warning"
                      size="small"
                      class="text-capitalize"
                      >Draft</v-chip
                    >
                    <v-chip
                      v-else
                      color="grey"
                      size="small"
                      class="text-capitalize"
                      >{{ item.status || 'Unknown' }}</v-chip
                    >
                  </template>

                  <template v-slot:item.created_at="{ item }">
                    {{ formatDate(item.created_at) }}
                  </template>
                  

                  <template v-slot:item.updated="{ item }">
                    {{ formatDate(item.updated_at || item.updated) }}
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <div class="d-flex gap-1 justify-end align-center flex-nowrap">
                      <!-- View Button -->
                      <v-btn
                        icon="mdi-eye"
                        size="small"
                        variant="text"
                        color="info"
                        @click="viewDocument(item)"
                        v-if="!isApprovalProcessActive(item)"
                        title="View Document"
                      />

                      <!-- Edit Button -->
                      <v-btn
                        icon="mdi-pencil"
                        size="small"
                        variant="text"
                        color="orange"
                        @click="editDocument(item)"
                        v-if="$updateAccess($route.fullPath) && item.approval_process_id == null"
                        title="Edit Document"
                      />

                      <!-- Download Button -->
                      <v-btn
                        icon="mdi-download"
                        size="small"
                        variant="text"
                        color="primary"
                        @click="downloadFile(item)"
                        title="Download Document"
                      />

                      <v-btn
                        icon="mdi-send-variant-outline"
                        size="small"
                        variant="text"
                        color="primary"
                        @click="sendDocument(item)"
                        title="Send Document"
                        v-if="isApprovalProcessActive(item)"
                      />

                      <!-- Delete Button -->
                      <v-btn
                        icon="mdi-delete"
                        size="small"
                        variant="text"
                        color="error"
                        @click="deleteDocument(item)"
                        v-if="$deleteAccess($route.fullPath)"
                        title="Delete Document"
                      />
                      <!-- <v-btn
                        v-if="item.approval_status == 'Returned'"
                        icon="mdi-plus-box-outline"
                        size="small"
                        variant="text"
                        color="secondary"
                        @click="addNewVersionDocument(item)"
                        title="New Version"
                      /> -->
                      
                    </div>
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <!-- Document Upload Modal -->
    <cmsDocumentUploadModal
      v-model:dialog="documentModalOpen"
      :document-data="selectedDocument"
      :is-edit-mode="isEditMode"
      @update:dialog="documentModalOpen = $event"
    />

    <!-- <cmsDocumentVersionUploadModal
      v-model:dialog="documentVersionModalOpen"
      :document-data="selectedDocument"
      :is-edit-mode="isEditMode"
      @update:dialog="documentVersionModalOpen = $event"
    /> -->
      <!-- @refresh="fetchDocuments" -->
    <cmsDocumentSendApproval
      v-model:dialog="documentSendApproval"
      :document-data="selectedDocuments"
      :is-edit-mode="isEditMode"
      @refresh="fetchDocuments"
      @update:dialog="documentSendApproval = $event"
    />
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref, onMounted } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import Axios from "axios";
import { getCmsFiles, deleteCmsFile } from "@/store/api";
import cmsDocumentUploadModal from "@/components/module/cms/documentManagement/cmsDocumentUploadModal.vue";
// import cmsDocumentVersionUploadModal from "@/components/module/cms/documentManagement/cmsDocumentVersionUploadModal.vue";
import cmsDocumentSendApproval from "@/components/module/cms/documentManagement/cmsDocumentSendApproval.vue";


export default {
  components: {
    cmsDocumentUploadModal,
    // cmsDocumentVersionUploadModal,
    cmsDocumentSendApproval
  },
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    loading: false,
    search: "",
    documentModalOpen: false,
    // documentVersionModalOpen: false,
    documentSendApproval: false,
    selectedDocument: null,
    isEditMode: false,
    statusOptions: [
      { title: "Pending", value: "Pending" },
      { title: "Approved", value: "Approved" },
      { title: "Forwarded", value: "Forwarded" },
      { title: "Returned", value: "Returned" },
    ],
    documentList: [],
    selectedDocuments: [],
    headers: [
      // {
      //   title: "Select",
      //   align: "center",
      //   key: "data-table-select",
      //   width: "3%",
      //   sortable: false,
      // },
      {
        title: "#SL",
        align: "center",
        key: "index",
        width: "7%",
        sortable: false,
      },
      // {
      //   title: "Doc No",
      //   key: "doc_no",
      //   align: "left",
      //   width: "10%",
      //   sortable: true,
      // },
      {
        title: "Code",
        key: "code",
        align: "left",
        width: "10%",
        sortable: true,
      },
      {
        title: "Icon",
        key: "icon_slot",
        align: "left",
        width: "5%",
        sortable: true,
      },
      {
        title: "Title",
        key: "title",
        align: "left",
        width: "10%",
        sortable: true,
      },
      {
        title: "Date",
        key: "document_date",
        align: "left",
        width: "10%",
        sortable: true,
      },
      {
        title: "Size",
        key: "size_slot",
        align: "center",
        width: "10%",
        sortable: true,
      },
      {
        title: "Version",
        key: "version",
        align: "center",
        width: "5%",
        sortable: true,
      },
      // {
      //   title: "Status",
      //   align: "center",
      //   key: "status",
      //   width: "10%",
      //   sortable: true,

      // },
      // {
      //   title: "Updated",
      //   align: "left",
      //   key: "updated",
      //   sortable: true,
      // },
      {
        title: "Approval Date",
        align: "left",
        key: "approved_date",
        width: "10%",
        sortable: true,
      },
      {
        title: "Approver",
        align: "left",
        key: "approved_by",
        width: "10%",
        sortable: true,
      },
      {
        title: "Approval Status",
        align: "left",
        key: "approved_status",
        width: "10%",
        sortable: true,
      },
      {
        title: "Actions",
        align: "center",
        key: "actions",
        sortable: false,
        width: "10%",
      },
    ],
  }),

  watch: {},

  created() {
    this.$store.dispatch("getDocumentsList");
  },
  
  computed:{
    documentList(){
      return this.$store.getters.getDocumentsList;
    },
      
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        // Add validation rules if needed
      }),
    });

    const docNo = useField("docNo");
    const title = useField("title");
    const status = useField("status");
    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const errorMessages = ref("");
    const loading = ref(false);
    const store = useStore();

    const submit = handleSubmit((values) => {
      loading.value = true;
       values.from_date = formattedDate(from_date.value.value);
        values.to_date = formattedDate(to_date.value.value);
      const params = {};
      store.dispatch("getDocumentsList", values)
        .then((response) => {
            loading.value = false;
        })
        .catch((error) => {            
            toast.error(error.response.data.message);          
        })
        // Axios.get(getCmsFiles, {
        //   params,
        // })
        //   .then((response) => {
        //     console.log(response.data.data)
        //     this.documentList = response.data?.data || [];
        //     this.loading = false;
        //   })
        //   .catch((error) => {
        //     console.error(error);
        //     this.loading = false;
        //     toast.error(error.response?.data?.message || "Failed to load documents");
        //   });
    });

    return {
      docNo,
      title,
      status,
      from_date,
      to_date,
      errorMessages,
      loading,
      submit,
      resetForm,
    };
  },
  methods: {
    getApprovalColor(status) {
      if (!status) {
        return { color: 'gray' };
      }

      switch (status.toLowerCase()) {
        case "pending":
          return { color: "#f47900" };

        case "approved":
          return { color: "green" };

        case "forwarded":
          return { color: "blue" };

        case "returned":
          return { color: "orange" };

        case "cancelled":
          return { color: "red" };

        default:
          return { color: "gray" };
      }
    },

    formatFileSize(bytes) {
      if (!bytes || bytes === 0) return '0 B';

      const k = 1024;
      const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];

      const i = Math.floor(Math.log(bytes) / Math.log(k));
      const value = bytes / Math.pow(k, i);

      return `${value.toFixed(2)} ${sizes[i]}`;
    },

    getFileIcon(file){
      const ext = file.stored_name.split(".").pop().toLowerCase();
      switch (ext) {
        case "pdf":
          return "mdi mdi-file-pdf-box";
        case "doc":
        case "docx":
          return "mdi mdi-file-word";
        case "xls":
        case "xlsx":
        case "csv":
          return "mdi mdi-microsoft-excel";
        case "jpg":
        case "jpeg":
        case "png":
          return "mdi mdi-image-album";
        case "ppt":
        case "pptx":
          return "mdi mdi-file-powerpoint";
        case "zip":
        case "rar":
        case "7z":
          return "mdi mdi-folder-zip";
        case "txt":
          return "mdi mdi-file-document-outline";
        default:
          return "mid mdi-file";
      }
    },

    getFileColor(file){
      const ext = file.stored_name.split(".").pop().toLowerCase();

      switch (ext) {
        case "pdf":
          return "red";
        case "doc":
        case "docx":
          return "blue";
        case "xls":
        case "xlsx":
        case "csv":
          return "green";
        case "jpg":
        case "jpeg":
        case "png":
          return "purple";
        case "ppt":
        case "pptx":
          return "orange";
        case "zip":
        case "rar":
        case "7z":
          return "brown";
        case "txt":
          return "grey";
        default:
          return "grey";
      }
    },


    async downloadFile(file){
      try {
        const blob = await this.$store.dispatch( "downlosdCmsFile", {fileId: file.id, type: "main_file", version: null});

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = file.original_name;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(link.href);

      } catch (error) {
        console.error("Download failed", error);
        alert("File download failed");
      }
    },
    isApprovalProcessActive(item) {
      return item.approval_process_id ? false : true;
    },
    toggleSelectAll() {
      if (this.selectedDocuments.length === this.documentList.length) {
        this.selectedDocuments = [];
      } else {
        this.selectedDocuments = this.documentList.map(doc => doc);
      }
    },
    selectAllDocuments(value) {
      if (value) {
        this.selectedDocuments = [...this.documentList];
      } else {
        this.selectedDocuments = [];
      }
    },
    formatDate(date) {
      if (!date) return "-";
      return formattedDate(date);
    },
    openDocumentModal() {
      this.selectedDocument = null;
      this.isEditMode = false;
      this.documentModalOpen = true;
    },
    // openDocumentVersionModal() {
    //   this.selectedDocument = null;
    //   this.isEditMode = false;
    //   this.documentVersionModalOpen = true;
    // },
    editDocument(item) {
      this.selectedDocument = { ...item };
      this.isEditMode = true;
      this.documentModalOpen = true;
    },
    openDocumentSendApprove(item = null) {
      if (item) {
        this.selectedDocuments = [item];
      }
      this.isEditMode = false;
      this.documentSendApproval = true;
    },
    editDocumentSendApprove(item) {
      // this.selectedDocuments = { ...item };
      this.isEditMode = true;
      this.documentSendApproval = true;
    },
    viewDocument(item) {
      this.$router.push({
          name: "approval-process-details",
          params: {
              id: item.id,
          },
          query: {
            referenceable_type: item?.approval_current_process?.referenceable_type,
            referenceable_id: item?.approval_current_process?.referenceable_id,
          }
      });
    },
    downloadDocument(item) {
      // Implement download document logic
      toast.info(`Downloading document: ${item.title}`);
    },
    deleteDocument(item) {
      if (confirm(`Are you sure you want to delete "${item.title}"?`)) {
        const token = localStorage.getItem("token");
        Axios.delete(deleteCmsFile(item.id), {
          headers: { Authorization: `Bearer ${token}` },
        })
          .then(() => {
            toast.success(`Document "${item.title}" deleted successfully`);
            this.fetchDocuments();
          })
          .catch((error) => {
            console.error(error);
            toast.error(error.response?.data?.message || "Failed to delete document");
          });
      }
    },
    
    addNewVersionDocument(item) {
      if (confirm(`Are you sure you want to update "${item.title}"?`)) {

        const token = localStorage.getItem("token");

        // Axios.delete(deleteCmsFile(item.id), {
        //   headers: { Authorization: `Bearer ${token}` },
        // })
        //   .then(() => {
        //     toast.success(`Document "${item.title}" deleted successfully`);
        //     this.fetchDocuments();
        //   })
        //   .catch((error) => {
        //     console.error(error);
        //     toast.error(error.response?.data?.message || "Failed to delete document");
        //   });
      }
    },

    fetchDocuments() { 
      return this.$store.getters.getDocumentsList;
    },
    exportToCSV() {
      toast.info("Exporting to CSV...");
      // Implement CSV export
    },
    exportToExcel() {
      toast.info("Exporting to Excel...");
      // Implement Excel export
    },
    exportToPDF() {
      toast.info("Exporting to PDF...");
      // Implement PDF export
    },
    sendDocument(item) {      
      // const selectedIds = this.selectedDocuments.map(doc => doc.id);
      // toast.info(`Sending ${this.selectedDocuments.length} document(s)...`);
      this.openDocumentSendApprove(item);
    },

    sendDocuments() {
      if (this.selectedDocuments.length === 0) {
        toast.warning("Please select documents to send");
        return;
      }
      this.openDocumentSendApprove();
    },
  },
  mounted() {
      this.from_date.value.value = new Date();
      this.to_date.value.value = new Date();
      this.$nextTick(() => {
          this.$refs.searchButton.$el.click();
      });   
  }  
};
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}
</style>
